import {ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {Localiser} from "../../services/localiser";
import {ProyectoService} from "../../services/proyecto.service";
import {Navigation} from "../../services/navigation.service";
import {luminaria} from "../../models/luminaria";
import {LuminariaService} from "../../services/luminaria.service";
import {PlanoService} from "../../services/plano.service";
import {ZonaService} from "../../services/zona.service";
import {plano} from "../../models/plano";
import {zona} from "../../models/zona";
import {concentrador} from "../../models/concentrador";
import {ParametrosService} from "../../services/parametros.service";
import {parametros} from "../../models/parametros";
import {ConcentradorService} from "../../services/concentrador.service";
import {main} from "@angular/compiler-cli/src/main";
import {retry} from "rxjs/operators";

@Component({
  selector: 'app-parameters',
  templateUrl: './parameters.component.html',
  styleUrls: ['./parameters.component.css']
})
export class ParametersComponent implements OnInit {

  luminarias: Array<luminaria> = [];
  luminariasFiltro: Array<luminaria> = [];
  luminariasReal: Array<luminaria> = [];
  loadingLums: boolean = false;
  searcherLuminarias: string = "";

  planos: Array<plano>;
  zonas: Array<zona>;
  showZonas: Array<zona> = [];
  planoSelected: plano;
  zonaSelected: zona;

  // All the gateways
  concentradores: Array<concentrador>;
  // All the main gateways that communicate
  concentradoresMain: Array<concentrador>;
  mainHub: concentrador = undefined;
  mntHub: concentrador = undefined;
  altHubs: Array<concentrador> = undefined;

  lumSelected: luminaria = undefined;
  gettingParameters: boolean = false;
  loadingParameters: boolean = false;
  settingParameters: boolean = false;
  parameterRequestPending: boolean = false;
  parameterRequestMessage: string = "";
  parametros: parametros[] = [];
  parametrosReal: parametros[] = [];
  parametrosTipo: Array<{ text: string; type: string }> = [];
  parametrosTipoSelected: { text: string; type: string } | undefined = undefined;

  param_blacklist = [
    {
      "tipo": "Zone",
      "parametros": ["enabled", "pcgMax", "pcgMin"]
    }
  ];

  constructor(public localiser: Localiser, private navigation: Navigation, private luminariaService: LuminariaService,
              private proyectoService: ProyectoService, private planoService: PlanoService, private zonaService: ZonaService,
              private parametrosService: ParametrosService, private concentradorService: ConcentradorService,
              private changeDetectorRef: ChangeDetectorRef) {
    if (!this.proyectoService.proyectoActualCookie()) {
      proyectoService.setTrueSelectALocation("parameters");
      this.navigation.toLocations();
    } else {
      proyectoService.setLastPage("parameters")
    }
  }

  ngOnInit(): void {
    this.getLuminarias();
    this.getPlanos();
    this.getZonas();
    this.getConcentradores();
  }

  getLuminarias() {
    this.loadingLums = true;
    this.luminariaService.getByIdProyectoWithPerifericos(this.proyectoService.getProyectoActual().idProyecto).subscribe((response: Array<luminaria>) => {
      this.luminariasReal = response;
      this.luminariasFiltro = this.luminariasReal;
      this.checkAllFilters();
      this.checkPerifericos();
      this.loadingLums = false;
    });
  }

  getPlanos() {
    this.planoService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<plano>) => {
      this.planos = result;
    })
  }

  getZonas() {
    this.zonaService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<zona>) => {
      this.zonas = result;
      this.showZonas = this.zonas;
    })
  }

  /*
    Method that get the concentradores/gateways/hubs and also separate the mainHubs in another list
   */
  getConcentradores() {
    this.concentradorService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<concentrador>) => {
      this.concentradores = result;
      this.concentradoresMain = this.concentradores.filter(gw => !gw.panId.includes("FF"));
    })
  }

  /*
    Method that load the Parametros directly from the luminary and update the database
   */
  loadParametrosFromGW() {
    if (!this.loadingParameters && !this.settingParameters) {
      this.loadingParameters = true;
      this.parameterRequestPending = true;
      this.parameterRequestMessage = "Loading parameters from device...";
      this.parametrosService.loadFromGW(this.lumSelected.idDispositivo, this.parametrosTipoSelected.type).subscribe((result: parametros[]) => {
        if (this.loadingParameters || this.settingParameters || this.gettingParameters) {
          let lista = [];

          for (let parametro of result) {
            for (let tipo_bloqueo of this.param_blacklist) {
              if (tipo_bloqueo["tipo"] != parametro.tipo || (tipo_bloqueo["tipo"] == parametro.tipo && !tipo_bloqueo["parametros"].includes(parametro.parametro))) {
                lista.push(parametro);
              }
            }
          }
          // }

          this.renderParametros(lista);
          this.loadingParameters = false;
          this.parameterRequestPending = false;
          this.parameterRequestMessage = "";
        }
      }, () => {
        this.loadingParameters = false;
        this.parameterRequestPending = false;
        this.parameterRequestMessage = "";
      });
    }
  }

  /*
    Method that get Parametros by IdDispositivo and ParametroTipo
   */
  getParametrosByIdDispositivoandParametroTipo() {
    this.gettingParameters = true;
    this.parametrosService.getByIdDispositivoAndTipo(this.lumSelected.idDispositivo, this.parametrosTipoSelected.type).subscribe((result: parametros[]) => {
      let lista = [];

      // if (this.parametrosTipoSelected.type != undefined && this.parametrosTipoSelected.type == "Zone") {
      for (let parametro of result) {
        for (let tipo_bloqueo of this.param_blacklist) {
          if (tipo_bloqueo["tipo"] != parametro.tipo || (tipo_bloqueo["tipo"] == parametro.tipo && !tipo_bloqueo["parametros"].includes(parametro.parametro))) {
            lista.push(parametro);
          }
        }
      }
      // }

      this.renderParametros(lista);
      this.gettingParameters = false;
    })
  }

  /*
    Method that render the table of Parametros in the web
   */
  renderParametros(parametros: parametros[]) {
    this.parametrosReal = parametros;
    this.orderParametros(this.parametrosReal);
    this.parametros = [];
    this.parametrosReal.forEach(val => this.parametros.push(Object.assign({}, val)));
    console.log(this.parametrosReal)
    console.log(this.parametros)
  }

  /*
    Method to order Parametros in order to show them correctly
      - Currently there is only the implementation for the MapOfHubs parameter type
      - Available in case is neccesary order other parameters
   */
  orderParametros(parametros: parametros[]) {
    if (this.parametrosTipoSelected.type == "MapOfHubs" && parametros.length > 0) {

      // Sort by his method
      parametros.sort(this.orderHubs);

      /*
        By the String values of the panID of each hub in MapOfHubs, assing the concentrador model to global variables
          - Three variables: mainHub, mntHub, altHubs (array)
          - From panID "0xFFFF" to "FFFF"
       */
      this.mainHub = this.concentradores.find(gw => gw.panId.split("x")[1] == JSON.parse(parametros.find(param => param.parametro == "mainHub").value).panID)
      this.mntHub = this.concentradores.find(gw => gw.panId.split("x")[1] == JSON.parse(parametros.find(param => param.parametro == "mntHub").value).panID)
      this.altHubs = [];
      JSON.parse(parametros.find(param => param.parametro == "altHubs").value).forEach(altGW => {
        this.altHubs.push(this.concentradores.find(gw => gw.panId.split("x")[1] == altGW.panID));
      })
    } else if (parametros.length > 0) {

      // Other parameters get ordered by its name
      parametros.sort((a, b) =>{
        return a.parametro.localeCompare(b.parametro);})
    }
  }

  /*
    Method to order correctly the MapOfHubs parameters
   */
  orderHubs(paramA: parametros, paramB: parametros): number {
    const orderArray: string[] = ["mainHub", "mntHub", "altHubs"];
    const indexA = orderArray.indexOf(paramA.parametro);
    const indexB = orderArray.indexOf(paramB.parametro);
    if (indexA === -1) {
      return 1;
    } else if (indexB === -1) {
      return -1;
    } else {
      return indexA - indexB;
    }
  }

  /*
    Method to change the Main Hub of the parameter type MapOfHubs
      - It also changes the mntHub because its defined by the main
   */
  changeSelectMainHub(parametro, hub: concentrador) {
    // Create a new JSON for the new hub and update the parameter
    let newHub = {panID: hub.panId.split("x")[1], channel: +hub.channel};
    parametro.value = JSON.stringify(newHub);
    this.updateParameter(parametro);

    // If it's changing the mainHub
    if (parametro.parametro == "mainHub") {
      // Get the mntHub from the new mainHub
      this.mntHub = this.concentradores.find(gw => gw.idDispositivo == hub.concentradorMantenimiento);
      if (this.mntHub != undefined) {
        this.changeSelectMainHub(this.parametros.find(param => param.parametro == "mntHub"), this.mntHub);
      }
    }
  }


  /*
    Method to change the Alt Hub of the parameter type MapOfHubs
   */
  changeSelectAltHub(parametro, index, hub: concentrador) {
    // Create a new JSON for the new hub and update the parameter
    let newHub = {panID: hub.panId.split("x")[1], channel: +hub.channel};
    let json = JSON.parse(parametro.value)

    // Build the new value of the parameters
    let newJson = [];
    if (index >= json.length) {
      newJson = json;
      newJson.push(newHub);
    } else {
      for (let param of json) {
        if (json.indexOf(param) == index) {
          newJson.push(newHub);
        } else {
          newJson.push(param);
        }
      }
    }
    parametro.value = JSON.stringify(newJson);
    this.updateParameter(parametro);
  }

  /*
    Method that returns an available hub to add in the alt hubs
      - It can only be selected by the list of mainHubs (this.concentradoresMain), altHub can't be mnt
      - It can't be selected from an already selected altHub (!this.altHubs.includes(gw))
      - It has to appear in the selector the actual selected hub (gw.idDispositivo == altHub.idDispositivo)
      - It can't be undefined (preventing error from empty altHubs selector)
   */
  availableAltHubs(altHub) {
    return this.concentradoresMain.filter(gw =>
      (!this.altHubs.includes(gw) || (altHub != undefined && gw.idDispositivo == altHub.idDispositivo)) &&
      gw != this.mainHub
    );
  }

  /*
    Method that returns true if it's possible add a new altHub
      - Used for show the "+" button
   */
  canAddAltHub() {
    return this.parametrosTipoSelected.type == "MapOfHubs" && ((this.altHubs.length <= 9
      && this.altHubs[this.altHubs.length - 1] != undefined) || this.altHubs.length == 0)
      && this.concentradoresMain.filter(gw => !this.altHubs.includes(gw)).length > 0;
  }

  /*
    Method that adds an empty altHub after press the "+" button
   */
  addAltHub() {
    this.altHubs.push(undefined);
  }

  /*
    Method that removes an altHub after press the "-" button
   */
  rmAltHub(parametro, index) {
    this.altHubs.splice(index, 1);

    let json = JSON.parse(parametro.value)
    let newJson = [];
    for (let param of json) {
      if (json.indexOf(param) != index) {
        newJson.push(param);
      }
    }
    parametro.value = JSON.stringify(newJson);
    this.updateParameter(parametro);
  }

  /*
    Method that reset Parametros to the original
   */
  resetParametros() {
    this.parametros = [];
    this.parametrosReal.forEach(val => this.parametros.push(Object.assign({}, val)));
    this.renderParametros(this.parametros);
  }

  /*
    Method that set new Parametros to a luminary
   */
  setParametrosWithIdDispositivo() {
    if (this.checkParametroIsChanged() && !this.loadingParameters && !this.settingParameters) {
      this.settingParameters = true;
      this.parameterRequestPending = true;
      this.parameterRequestMessage = "Waiting for device write confirmation...";
      if (this.parametros.length > 0) {
        this.parametrosService.setWithIdDispositivo(this.proyectoService.getProyectoActual().idProyecto, this.lumSelected.idDispositivo, this.parametrosTipoSelected.type, this.parametros).subscribe((result: parametros[]) => {
          this.renderParametros(result);
          this.settingParameters = false;
          this.parameterRequestPending = false;
          this.parameterRequestMessage = "";
        }, () => {
          this.settingParameters = false;
          this.parameterRequestPending = false;
          this.parameterRequestMessage = "";
        })
      }
    }
  }

  selectPlano(planoEv) {
    if (planoEv == -1 || planoEv == null || planoEv == "all") {
      this.planoSelected = undefined;
      this.zonaSelected = undefined;
      this.showZonas = this.zonas;
    } else {
      this.planoSelected = this.planos.find(plano => plano.idPlano == planoEv.idPlano);
      this.zonaSelected = undefined;
      this.showZonas = this.zonas.filter(zona => {
        return zona.idPlano == this.planoSelected.idPlano;
      });
    }
    this.checkAllFilters();
  }

  selectZona(zonaEv) {
    if (zonaEv == -1 || zonaEv == null || zonaEv == "all") {
      this.zonaSelected = undefined;
    } else {
      this.planoSelected = this.planos.find(plano => plano.idPlano == zonaEv.idPlano);
      this.zonaSelected = this.showZonas.find(zona => zona.id == zonaEv.id);
      this.showZonas = this.zonas.filter(zona => {
        return zona.idPlano == zonaEv.idPlano;
      });
    }
    this.checkAllFilters();
  }

  /*
    Method that check the filters
   */
  checkAllFilters() {
    // Get all luminarias
    this.luminariasFiltro = this.luminariasReal;

    // Filter by selected plano
    if (this.planoSelected != undefined) {
      this.luminariasFiltro = this.luminariasFiltro.filter(luminaria => luminaria.idPlano == this.planoSelected.idPlano);
    }

    // Filter by selected zona
    if (this.zonaSelected != undefined) {
      this.luminariasFiltro = this.luminariasFiltro.filter(luminaria => luminaria.idZona == this.zonaSelected.id);
    }

    // Filter by input name or ID
    this.luminariasFiltro = this.luminariasFiltro.filter(luminaria =>
      (luminaria.nombre.toLowerCase().includes(this.searcherLuminarias.toLowerCase())) ||
      (luminaria.idDispositivo.toLowerCase().includes(this.searcherLuminarias.toLowerCase())));

    this.luminarias = this.luminariasFiltro;

    if (!this.luminarias.includes(this.lumSelected)) {
      this.unselectLuminary();
    }
  }

  /*
    Method that check Perifericos of a luminary and add the ParametrosTipo for each one
   */
  checkPerifericos() {
    if (this.lumSelected != undefined) {
      this.parametrosTipo = [
        {text: this.localiser.get("parameters.stateMachine"), type: "MoS"},
        {text: this.localiser.get("parameters.loraParameters"), type: "LoRa_Param"},
        {text: this.localiser.get("parameters.hubsMap"), type: "MapOfHubs"},
        {text: this.localiser.get("parameters.groups"), type: "Group"},
        {text: this.localiser.get("parameters.profiles"), type: "Fade"},
        {text: this.localiser.get("parameters.zonesAndRules"), type: "Zone"}];
      if (this.lumSelected.perifericos != undefined) {
        if (this.lumSelected.perifericos.h420 != -1) {
          this.parametrosTipo.push({text: this.localiser.get("parameters.thresholds"), type: "4.20mA"});
        }
        if (this.lumSelected.perifericos.innosent != -1) {
          this.parametrosTipo.push({text: this.localiser.get("parameters.innosent"), type: "Innosent"});
        }
        if (this.lumSelected.perifericos.relay != -1) {
          this.parametrosTipo.push({text: this.localiser.get("parameters.relay"), type: "Relay"});
        }
      }
      this.changeSelectType(this.parametrosTipo[0]);
    }
  }

  /*
    Method that check is Parametro is changed in order to able the set button
   */
  checkParametroIsChanged() {
    return JSON.stringify(this.parametrosReal) != JSON.stringify(this.parametros);
  }

  /*
    Method that unselect a luminary
   */
  unselectLuminary() {
    this.lumSelected = undefined;
    this.gettingParameters = false;
    this.loadingParameters = false;
    this.settingParameters = false;
    this.parameterRequestPending = false;
    this.parameterRequestMessage = "";
    this.parametros = [];
  }

  getPlanoNameById(idPlano) {
    let plano = this.planos.find(plano => plano.idPlano == idPlano);
    if (plano != undefined) {
      return plano.nombre;
    } else {
      return '---';
    }
  }

  getZonaNameById(idZona) {
    let zona = this.zonas.find(zona => zona.id == idZona);
    if (zona != undefined) {
      return zona.nombre;
    } else {
      return '---';
    }
  }

  /*
    Method that changes a selected luminary
   */
  changeSelectLum(luminaria: luminaria) {
    this.lumSelected = luminaria;
    this.gettingParameters = false;
    this.loadingParameters = false;
    this.settingParameters = false;
    this.parameterRequestPending = false;
    this.parameterRequestMessage = "";
    this.checkPerifericos();
  }

  /*
    Method that changes the selected Parametro Type
   */
  changeSelectType(parametrosTipo) {
    this.parametrosTipoSelected = parametrosTipo;
    this.parameterRequestPending = false;
    this.parameterRequestMessage = "";
    this.getParametrosByIdDispositivoandParametroTipo();
  }

  /*
    Method that get and transform the last communication of a Parametro for show it in the web
   */
  getLastComm(timestamp) {
    let date = new Date(timestamp)
    return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear() + " - " +
      date.getHours() + ":" + (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes());
  }

  /*
    Method that changes a Parametro number by its restrictions
   */
  changeParameterNumber(parametro: parametros) {
    let input;
    if (parametro.value > parametro.max) {
      input = parametro.max;
    } else if (parametro.value < parametro.min) {
      input = parametro.min;
    } else {
      input = parametro.value;
    }
    parametro.value = undefined;
    this.changeDetectorRef.detectChanges();
    parametro.value = input;
    this.updateParameter(parametro);
  }

  getCustomValue(parametro, n) {
    if (parametro == "bandwidth") {
      return this.getBandWidthText(n);
    } else {
      return n;
    }
  }

  getBandWidthText(n) {
    if (n == 7) {
      return "125";
    } else if (n == 8) {
      return "250";
    } else if (n == 9) {
      return "500";
    }
    return "";
  }

  /*
    Method that checks if there is no data loaded
   */
  checkNoData() {
    return !this.gettingParameters && this.parametros && this.parametros.length == 0;
  }

  /*
    Method that update a Parametro in the web memory
   */
  updateParameter(param) {
    this.parametros.find(p => p.parametro == param.parametro).value = param.value.toString();
  }
  /*
    Decimal to binary to print the masks for groups and sensors
   */
  dec2bin(n) {
    return (n >>> 0).toString(2);
  }


  /*
    Navigation methods
   */
  toZone() {
    this.navigation.toAteneoZones();
  }

  toFade() {
    this.navigation.toFade();
  }

  toThresholds() {
    this.navigation.toLimits();
  }

}
